"use strict";

var React = require('react'),
    ReactRouter = require('react-router'),
    Cmp = require('../../components'),
    Constants = require('../../constants'),
    CurrentUser = require('../../shared/CurrentUser'),
    _ = require('underscore'),
    FluxBone = require('../../mixins/FluxBone');

var ToolboxHeader = React.createClass({displayName: "ToolboxHeader",
    mixins: [
        ReactRouter.Navigation
    ],

    contextTypes: {
        router: React.PropTypes.func
    },

    render: function() {
        var me = this,
            props = me.props,
            state = me.state,
            model = props.project || props.builder,
            name = model ? model.get('name').replace(/\s/g, '\u00A0') : '';

        return (
            React.createElement("div", {className: "header"}, 
                React.createElement("div", {className: "container"}, 
                    React.createElement("div", {className: "logo"}, 
                        props.builder ? (
                            React.createElement("h1", null, 
                                "Agent Portal: ", 
                                React.createElement(Cmp.Select.Listings, {label: "", className: "blue-control", defaultText: "Show All", value: props.project ? props.project.id : '', store: props.builder.listingCollection, onChange: this.onChangeProject})
                            )
                        ) : (
                            React.createElement("h1", null, "Agent Portal: ", React.createElement("span", {className: "blue-text"}, name))
                        )
                    ), 
                    React.createElement("div", {className: "topbar padding-bottom-0"}, 
                        React.createElement("ul", {className: "loginbar pull-right"}, 
                            React.createElement(Cmp.NavLink, {href: CurrentUser.getEditUrl(), target: "_blank"}, React.createElement("i", {className: "fa fa-pencil-square-o"}), " Edit Your Account"), " ", 
                            React.createElement(Cmp.NavLink, {onClick: this.doLogout}, React.createElement("i", {className: "fa fa-unlock-alt"}), " Logout")
                        )
                    )
                )
            )
        );
    },

    doLogout: function() {
        var me = this;
        CurrentUser.logout().always(function() {
            me.transitionTo('Login', undefined, _.result(Constants, 'query'));
        });
    },

    onChangeProject: function(e) {
        var me = this,
            projectId = e.target.value,
            project = me.props.builder.listingCollection.get(projectId),
            apiKey = project ? project.get('apiKey') : undefined,
            router = me.context.router,
            routes = router.getCurrentRoutes(),
            routeName = routes[routes.length - 1].name,
            query = router.getCurrentQuery(),
            params = router.getCurrentParams(),
            restrictedRoutes = ['Widgets', 'PersonalizedEmail', 'PersonalizedBrochure'];

        if(!project) {
            routeName = 'Dashboard';
        } else if(routeName === 'Widgets' && !project.hasServiceType('AGENT_PORTAL')) {
            routeName = 'Dashboard';
        } else if((routeName === 'PersonalizedEmail' || routeName === 'PersonalizedBrochure') && !project.hasServiceType('PERSONALIZED_BROCHURES')) {
            routeName = 'Dashboard';
        }

        if(projectId) {
            me.transitionTo(routeName, params, _.extend({}, query, _.result(Constants, 'query'), { API: apiKey }));
        } else {
            me.transitionTo('Dashboard', params, _.omit(_.extend({}, query, _.result(Constants, 'query')), 'API'));
        }
    }
});

module.exports = ToolboxHeader;
